import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  setLPMWelcome(value) {
    localStorage.setItem('lpmWelcome', value);
  }

  setCCAOriginURL(value) {
    localStorage.setItem('origin_url', value);
  }

  clearCCAOriginURL() {
    localStorage.removeItem('origin_url');
  }

  getCCAOriginURL() {
    return localStorage.getItem('origin_url');
  }

  getLPMWelcome() {
    return localStorage.getItem('lpmWelcome') === 'true';
  }

  cleanAll() {
    localStorage.clear();
  }

  setClioGetAuthorizationCodeV3Executed(value) {
    localStorage.setItem('getAuthorizationCodeV8Executed', value);
  }

  getClioGetAuthorizationCodeV3Executed() {
    return localStorage.getItem('getAuthorizationCodeV8Executed') === 'true';
  }
}
